import { request } from "./apiRequest";

export interface BroadcastResult {
  recipientCount: number;
  sent: number;
  failed: number;
}

export const notificationsClient = {
  broadcast: (subject: string, message: string) =>
    request<BroadcastResult>("/notifications/admin/broadcast", { method: "POST", body: JSON.stringify({ subject, message }) }),
  sendToEmployee: (email: string, subject: string, message: string) =>
    request<{ sent: boolean }>("/notifications/admin/send", { method: "POST", body: JSON.stringify({ email, subject, message }) }),
};
